import { render } from "./Game.vue?vue&type=template&id=72642512"
const script = {}

import "./Game.vue?vue&type=style&index=0&id=72642512&scss=true&lang=css"

import exportComponent from "E:\\project2\\skin-web\\英雄攻战\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__